











































import Vue from 'vue';
import { Tab } from '~/components/builders/Tabs.vue';
import Header from '~/components/layouts/Header.vue';
import MainLayout from '~/components/layouts/mainlayout/MainLayout.vue';
import BillingService, { BillingAccount } from '~/services/BillingService';
import Invoices from './sections/Invoices.vue';
import Payment from './sections/Payment.vue';
import Purchases from './sections/Purchases.vue';
import Subscriptions from './sections/Subscriptions.vue';

export enum PlansAndBillingTab {
    Subscriptions = 'subscriptions',
    Purchases = 'purchases',
    Invoices = 'invoices',
    Payment = 'payment',
}

export default Vue.extend({
    name: 'PlansAndBilling',
    components: {
        Header,
        MainLayout,
        Purchases,
        Subscriptions,
        Payment,
        Invoices,
    },
    data() {
        return {
            section: 'subscriptions' as PlansAndBillingTab,
            sections: PlansAndBillingTab,

            billingAccount: null as BillingAccount | null,

            error: false,
        };
    },
    computed: {
        tabs(): Tab[] {
            return Object.values(PlansAndBillingTab).map<Tab>(value => ({
                value,
                label: this.$t(`plansAndBilling.tabs.${value}`).toString(),
            }));
        },

        user(): any {
            // TODO: Check if there exists typing for interfaces/User return
            const { data } = (this as any).$interfaces.user.me.get({ reactive: true });

            return data && (!Array.isArray(data) || data.length !== 0) ? data : null;
        },
        headerLabel(): string {
            return this.$t('plansAndBilling.header').toString();
        },
    },
    methods: {
        getInitialTab(): PlansAndBillingTab {
            const params = new URLSearchParams(window.location.search);

            const tab = params.get('tab');
            if (!!tab && Object.values(PlansAndBillingTab).includes(tab as PlansAndBillingTab))
                return tab as PlansAndBillingTab;

            return PlansAndBillingTab.Subscriptions;
        },
    },
    mounted() {
        this.section = this.getInitialTab();
        BillingService.getDefaultBillingAccount()
            .then(account => (this.billingAccount = account))
            .catch(err => {
                console.error(err);
                this.error = true;
            });
    },
});
